import {Lang} from 'yougile-lang'
import {DataField} from 'yougile-model'

export const getDefaultContactPersonFields = (): DataField[] => [
  {
    id: 'contact-position',
    type: 'string',
    label: Lang.msg.crm.rightPanel.contactPerson.position
  },
  {
    id: 'contact-phone',
    type: 'string',
    label: Lang.msg.crm.rightPanel.contactPerson.phone
  },
  {
    id: 'contact-email',
    type: 'email',
    label: Lang.msg.crm.rightPanel.contactPerson.email
  },
  {
    id: 'contact-address',
    type: 'string',
    label: Lang.msg.crm.rightPanel.contactPerson.address
  }
]

export const getDefaultOrganizationFields = (): DataField[] => [
  {
    id: 'org-phone',
    type: 'string',
    label: Lang.msg.crm.rightPanel.contactPerson.phone
  },
  {
    id: 'org-website',
    type: 'url',
    label: Lang.msg.crm.rightPanel.contactPerson.website
  },
  {
    id: 'org-address',
    type: 'string',
    label: Lang.msg.crm.rightPanel.contactPerson.address
  }
]

// NOTE: backward compatibility with deprecated format of fields
// (was made in CRM beta-version), can be safely removed after ~15 July 2025.
export const getLegacyCrmFieldValueById = (
  data: any,
  id: string
): string | undefined => {
  return data?.fields?.find((f: any) => f?.key === id)?.value
}
